import React, { useState } from 'react';
import { Sidebar } from '@/components/Sidebar';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

export default function PrototypeOption1() {
  const navigate = useNavigate();
  
  return (
    <div className="flex min-h-screen bg-[#0A0A0B] text-[#F8F9FA]">
      <Sidebar />
      <div className="flex-1 px-4 md:px-6 lg:px-8 py-6 md:py-8">
        <div className="flex items-center gap-4 mb-6">
          <Button
            variant="outline"
            size="icon"
            onClick={() => navigate('/ib-management')}
            className="border-[#2A2A2E] hover:border-[#3A3A3F] hover:bg-[#1C1C1F] text-[#F8F9FA]"
          >
            <ArrowLeft size={20} />
          </Button>
          <div>
            <h1 className="text-4xl font-bold font-heading text-[#F8F9FA]">
              FIRA IND
            </h1>
            <p className="text-[#ADB5BD]">IB Details dengan Tabs</p>
          </div>
        </div>

        <div className="border border-[#E63946] bg-[#E63946]/5 rounded-lg p-6 mb-6">
          <h2 className="text-xl font-semibold text-[#E63946] mb-2">✨ OPTION 1: TABS SYSTEM</h2>
          <p className="text-[#ADB5BD]">Semua sub-modules dalam SATU page dengan tabs untuk switch antara sections</p>
        </div>

        <Tabs defaultValue="overview" className="w-full">
          <TabsList className="bg-[#141416] border border-[#2A2A2E] mb-6 flex-wrap h-auto">
            <TabsTrigger value="overview">Channel Overview</TabsTrigger>
            <TabsTrigger value="profile">Channel Profile</TabsTrigger>
            <TabsTrigger value="performance">Channel Performance</TabsTrigger>
            <TabsTrigger value="analytic">Channel Analytic</TabsTrigger>
            <TabsTrigger value="activity">Channel Activity</TabsTrigger>
            <TabsTrigger value="campaign">Channel Campaign</TabsTrigger>
            <TabsTrigger value="daily">Daily Data</TabsTrigger>
            <TabsTrigger value="database">Database Segmentation</TabsTrigger>
            <TabsTrigger value="log">Log</TabsTrigger>
          </TabsList>

          <TabsContent value="overview">
            <div className="border border-[#2A2A2E] bg-[#141416] rounded-lg p-8">
              <h3 className="text-2xl font-semibold mb-4">Channel Overview</h3>
              <p className="text-[#ADB5BD]">Performance Scorecard, Projection, Health, Funnel, Achievement...</p>
              <div className="grid grid-cols-4 gap-4 mt-6">
                <div className="border border-[#2A2A2E] rounded p-4">
                  <p className="text-xs text-[#ADB5BD]">Commission</p>
                  <p className="text-2xl font-mono text-[#F8F9FA]">MYR 1,288</p>
                </div>
                <div className="border border-[#2A2A2E] rounded p-4">
                  <p className="text-xs text-[#ADB5BD]">Traded Lot</p>
                  <p className="text-2xl font-mono text-[#F8F9FA]">116.87</p>
                </div>
                <div className="border border-[#2A2A2E] rounded p-4">
                  <p className="text-xs text-[#ADB5BD]">Active Client</p>
                  <p className="text-2xl font-mono text-[#F8F9FA]">373</p>
                </div>
                <div className="border border-[#2A2A2E] rounded p-4">
                  <p className="text-xs text-[#ADB5BD]">Deposit</p>
                  <p className="text-2xl font-mono text-[#F8F9FA]">MYR 44k</p>
                </div>
              </div>
            </div>
          </TabsContent>

          <TabsContent value="profile">
            <div className="border border-[#2A2A2E] bg-[#141416] rounded-lg p-8">
              <h3 className="text-2xl font-semibold mb-4">Channel Profile</h3>
              <p className="text-[#ADB5BD]">IB Biography, Monthly Target, Team Members, Social Media...</p>
            </div>
          </TabsContent>

          <TabsContent value="performance">
            <div className="border border-[#2A2A2E] bg-[#141416] rounded-lg p-8">
              <h3 className="text-2xl font-semibold mb-4">Channel Performance</h3>
              <p className="text-[#ADB5BD]">Marketing, Sales, Operation tabs dengan Funnel Score & Metric Score...</p>
            </div>
          </TabsContent>

          <TabsContent value="daily">
            <div className="border border-[#2A2A2E] bg-[#141416] rounded-lg p-8">
              <h3 className="text-2xl font-semibold mb-4">Daily Data</h3>
              <p className="text-[#ADB5BD]">Marketing, Sales, Operation daily input table...</p>
            </div>
          </TabsContent>

          <TabsContent value="analytic">
            <div className="border border-[#2A2A2E] bg-[#141416] rounded-lg p-8">
              <h3 className="text-2xl font-semibold mb-4">Channel Analytic</h3>
              <p className="text-[#ADB5BD]">TGStat data - Subs in/out, Engagement, Views...</p>
            </div>
          </TabsContent>

          <TabsContent value="activity">
            <div className="border border-[#2A2A2E] bg-[#141416] rounded-lg p-8">
              <h3 className="text-2xl font-semibold mb-4">Channel Activity</h3>
              <p className="text-[#ADB5BD]">Activity calendar - Livetrade, Webinar, Signal...</p>
            </div>
          </TabsContent>

          <TabsContent value="campaign">
            <div className="border border-[#2A2A2E] bg-[#141416] rounded-lg p-8">
              <h3 className="text-2xl font-semibold mb-4">Channel Campaign</h3>
              <p className="text-[#ADB5BD]">Campaign list with status, health score, KPI...</p>
            </div>
          </TabsContent>

          <TabsContent value="database">
            <div className="border border-[#2A2A2E] bg-[#141416] rounded-lg p-8">
              <h3 className="text-2xl font-semibold mb-4">Database Segmentation</h3>
              <p className="text-[#ADB5BD]">Client CRM data - VIP/Elite segmentation...</p>
            </div>
          </TabsContent>

          <TabsContent value="log">
            <div className="border border-[#2A2A2E] bg-[#141416] rounded-lg p-8">
              <h3 className="text-2xl font-semibold mb-4">Log</h3>
              <p className="text-[#ADB5BD]">Documentation by department - before/after score...</p>
            </div>
          </TabsContent>
        </Tabs>

        <div className="mt-8 border border-[#06D6A0] bg-[#06D6A0]/5 rounded-lg p-6">
          <h3 className="text-lg font-semibold text-[#06D6A0] mb-2">✅ KELEBIHAN OPTION 1:</h3>
          <ul className="text-[#ADB5BD] space-y-1 ml-4">
            <li>• Semua info dalam 1 page - tak perlu reload</li>
            <li>• Quick switching dengan tabs</li>
            <li>• Clean & organized</li>
            <li>• Easy navigation (breadcrumb style)</li>
          </ul>
          <h3 className="text-lg font-semibold text-[#E63946] mb-2 mt-4">❌ KEKURANGAN:</h3>
          <ul className="text-[#ADB5BD] space-y-1 ml-4">
            <li>• Banyak tabs boleh jadi overwhelming</li>
            <li>• Mobile view mungkin susah (tabs overflow)</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
